import {
  UseMutationResult,
  useMutation,
  useQueryClient
} from '@tanstack/react-query'
import { graphql } from 'ms-client/graphql/user-pool'
import { useRouter } from 'next/router'

import {
  CreateMemberInvitedUserMutation,
  CreateMemberInvitedUserMutationVariables
} from '~workspace/types/__generated/gql/graphql'

import {
  GetWorkspaceByIdResults,
  getWorkspaceByIdQueryKey
} from './useGetWorkspaceById'

const createMemberInvitedUserMutation = /* GraphQL */ `
  mutation CreateMemberInvitedUser($email: String!, $workspaceId: ID!) {
    createMemberInvitedUser(email: $email, workspaceId: $workspaceId)
  }
`

export type CreateMemberInvitedUserResults =
  CreateMemberInvitedUserMutation['createMemberInvitedUser']

export type CreateMemberInvitedUserVariables =
  CreateMemberInvitedUserMutationVariables

export const useCreateMemberInvitedUser = (): UseMutationResult<
  CreateMemberInvitedUserResults,
  Error,
  CreateMemberInvitedUserVariables
> => {
  const {
    query: { workspaceId }
  } = useRouter()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['createMemberInvitedUser'],
    mutationFn: async (variables: CreateMemberInvitedUserVariables) => {
      const data = await graphql<
        CreateMemberInvitedUserMutation,
        CreateMemberInvitedUserMutationVariables
      >({
        query: createMemberInvitedUserMutation,
        variables
      })

      return data?.createMemberInvitedUser
    },
    onSuccess: () => {
      queryClient.setQueryData<GetWorkspaceByIdResults>(
        getWorkspaceByIdQueryKey(String(workspaceId)),
        (prev) => {
          if (!prev) return
          return { ...prev }
        }
      )

      queryClient.invalidateQueries({
        queryKey: getWorkspaceByIdQueryKey(String(workspaceId)),
        exact: true
      })
    }
  })
}
